import { CurrencyDisplay, PrimaryButton } from "components";
import { Accordion, Dialog, DialogContent } from "@material-ui/core";
import { InnoTableV2 } from "inno-ui";
import { Grid, Typography } from "@mui/material";

const DetailPaymentMutation = ({
  modalVisible,
  onClose,
  detailReport,
  queryParamsDetail,
  tableTotalPageDetail,
  handleChangeQueryParams,
}) => {
  return (
    <Dialog open={modalVisible} onClose={onClose} fullWidth maxWidth="md">
      <DialogContent>
        <Typography fontSize={24} fontWeight={500} m="12px 0 20px">
          Revenue Information
        </Typography>
        <Accordion>
          <InnoTableV2
            columns={columnTable}
            items={detailReport || []}
            isLoading={false}
            page={queryParamsDetail?.page}
            rowsPerPage={queryParamsDetail?.size}
            totalPage={tableTotalPageDetail}
            handleChangePage={(_, page) =>
              handleChangeQueryParams(page, "page")
            }
            handleChangeRowsPerPage={e =>
              handleChangeQueryParams(e?.target?.value, "size")
            }
            isH
          />
        </Accordion>
      </DialogContent>
    </Dialog>
  );
};

const columnTable = [
  {
    name: "song_title",
    title: "Song",
  },
  {
    name: "value",
    title: "Value",
    headerAlign: "right",
    renderText: item => <CurrencyDisplay value={item} prefix="Rp" />,
  },
];

export default DetailPaymentMutation;
